import type { Messages } from './en';

/**
 * Fase E (paquet hlcity): Hualien ciutat, mercat nocturn de Dongdamen, Pine Garden i Ji'an.
 * Les línies de pràctica d'anglès es queden en anglès expressament.
 */
export const caHlcity: Pick<Messages, 'hlcity'> = {
  hlcity: {
    mapNames: { hlcity: 'Hualien ciutat' },
    zones: {
      hcStation: 'Estació de Hualien',
      hcCreative: 'Parc Cultural i Creatiu',
      hcPine: 'Pine Garden (Songyuan)',
      hcMeilun: 'Riu Meilun',
      hcSnacks: 'Carrer de menjar del centre',
      hcIndigenous: 'Carrer Indígena',
      hcMainland: 'Carreró del Continent',
      hcDongdamen: 'Mercat nocturn de Dongdamen',
      hcHotel: 'Hotel vora el mar',
      hcBike: 'Carril bici de la costa',
      hcBeibin: 'Parc Beibin',
      hcContainer: 'Container Coffee',
      hcQingxiu: 'Temple Qingxiu',
      hcPaddies: "Arrossars de Ji'an",
      hcJian: "Ji'an",
      hlcity: 'Hualien ciutat',
    },
    objects: {
      hc_shuttle: 'Parada del Tourist Shuttle',
      hc_mural: 'Mural amis',
      hc_shrine: 'Altar del Déu de la Terra',
      hc_marketMap: 'Mapa del mercat nocturn',
      hc_dumpling: 'Parada de raviolis xinesos',
      hc_beefNoodle: 'Parada de sopa de fideus amb vedella',
      hc_xlb: 'Parada de xiaolongbao',
      hc_sausage: 'Parada de botifarres a la brasa',
      hc_bamboo: "Parada d'arròs en canya de bambú",
      hc_crafts: 'Artesania amis',
      hc_icecream: 'Rotlle de gelat amb cacauet',
      hc_tea: 'Parada de te amb boletes',
      hc_balloon: 'Dards i globus',
      hc_creative: 'Cartell del Parc Cultural',
      hc_pineGarden: 'Pedra del Pine Garden',
      hc_riverMouth: 'Mirador de la desembocadura',
      hc_bikePath: 'Cartell del carril bici',
      hc_seafront: 'Prismàtics del passeig marítim',
      hc_container: 'Carta del Container Coffee',
      hc_photo: 'Racó per fer fotos',
      hc_temple: 'Sala del temple Qingxiu',
      hc_buddha88: 'Els 88 Budes',
      hc_paddy: "Cartell de l'arrossar",
      hc_store: 'Botiga Good Neighbor',
    },
    npc: {
      hc_stationStaff: "Treballadora de l'estació",
      hc_taxiDriver: 'Taxista',
      hc_shuttleGuide: "Guia de l'autobús turístic",
      hc_dumplingGrandpa: "L'avi dels raviolis",
      hc_sausageVendor: "L'oncle de les botifarres",
      hc_amisGrandma: 'Àvia amis',
      hc_balloonVendor: 'La senyora de la parada',
      hc_singer: 'Cantant del mercat',
      hc_cyclist: 'Ciclista',
      hc_jogger: 'Corredora',
      hc_barista: 'Barista',
      hc_caretaker: 'Guarda del temple',
      hc_pineGuide: 'Guia del Pine Garden',
      hc_farmer: "Pagès d'arròs",
    },
    items: {},

    closed: 'La parada està tapada amb una lona. El mercat nocturn de Dongdamen obre a les 5 de la tarda: torna aquest vespre!',
    stampHint: 'La teva primera mossegada a Dongdamen: un segell nou al passaport!',
    look: '👀 Només mirar',
    back: '↩️ Tornar',

    // Menjar demanat en anglès (vendor, ok i bad són pràctica d'anglès).
    food: {
      dumpling: { vendor: 'Pork dumplings, boiled fresh! Ten or twenty?', ok: 'Ten dumplings, please. With soy sauce.', bad: ['Dumplings. Hundred. Go.', 'I am a dumpling, please.'], done: "Deu raviolis sucosos, acabats de treure de l'olla. Suca, bufa i mossega!", price: 40 },
      beefNoodle: { vendor: 'Beef noodle soup! Clear soup or red braised?', ok: 'Red braised, please. A small bowl.', bad: ['Noodle! Beef! Fast!', 'Cow soup for one cow.'], done: "Vedella tendra, fideus elàstics i un brou fosc i gustós. L'avi va aprendre la recepta del seu pare.", price: 60 },
      xlb: { vendor: 'Xiaolongbao! Soup inside — be careful, it’s hot!', ok: 'One basket, please. Thank you!', bad: ['Give me hot soup balls.', 'Basket. Now. Me.'], done: 'Hi fas un foradet, xarrupes la sopa i després et menges el ravioli. Mmm!', price: 50 },
      sausage: { vendor: 'Grilled pork sausage with garlic! Small or big?', ok: 'One small sausage, please.', bad: ['Sausage. Biggest. Free.', 'I want a sausage tree.'], done: 'Fumada, dolça i sucosa: la botifarra es cou sobre carbó. El mos preferit del Carrer Indígena!', price: 30 },
      bamboo: { vendor: 'Bamboo-tube rice! Sticky rice cooked inside bamboo.', ok: 'Could I have one, please? It smells great!', bad: ['Bamboo. Eat. Me.', 'One panda, please.'], done: "El senyor obre la canya de bambú: l'arròs és enganxós i fa olor de bosc. Les famílies amis el cuinen per a les festes.", price: 45 },
      crafts: { vendor: 'Handmade bracelets! Glass beads in many colours.', ok: 'Could I have the red one, please? It’s beautiful.', bad: ['Bracelet. Cheap. Now.', 'Give me all the beads.'], done: "L'àvia et lliga la polsera al canell. «El vermell és força i alegria», et diu somrient.", price: 20 },
      icecream: { vendor: 'Peanut ice-cream roll! With coriander or without?', ok: 'Without coriander, please. One roll.', bad: ['Ice cream. Wrap. Fast.', 'Coriander only, no ice cream.'], done: 'Torró de cacauet ratllat i dues boles de gelat embolicats en una crep ben fina. Cruixent i fresquet!', price: 35 },
      tea: { vendor: 'Bubble tea! Sugar level and ice level?', ok: 'Half sugar, less ice, please.', bad: ['Tea. Bubbles. Max.', 'All the sugar in the world.'], done: 'Boletes de tapioca toves i un te amb llet ben cremós. Amb la meitat de sucre està perfecte!', price: 30 },
      container: { vendor: 'Welcome to Container Coffee! What would you like?', ok: 'Can I have a small hot chocolate, please?', bad: ['Chocolate. Hot. Give.', 'I want the whole container.'], done: "Una tassa calenteta amb una oneta dibuixada a l'escuma. Te la prens mirant els contenidors apilats.", price: 30 },
      store: { vendor: 'Welcome! Hot tea eggs and baked sweet potatoes today.', ok: 'One tea egg, please. How much is it?', bad: ['Egg. Tea. Money no.', 'One store, please.'], done: "L'ou de te és marró i jaspiat, cuit a foc lent amb te i espècies. Totes les botigues 24 hores de Taiwan en tenen una olla!", price: 12 },
    },

    // Llocs.
    shuttle: 'Aquí para el Taiwan Tourist Shuttle: autobusos a la Gorja de Taroko i a la platja de Qixingtan.',
    mural: "El mural de l'estació mostra dibuixos amis: vermell per a la força, rombes blancs i groc per al sol. Els amis són el poble indígena més gran de Taiwan, i molts viuen a prop de Hualien.",
    muralQ: 'What do the Amis celebrate every summer?',
    muralA: ['The harvest festival', 'A snow festival', 'Halloween'],
    muralRight: "Sí! La festa de la collita (Ilisin): canten i ballen en un gran cercle per donar les gràcies per l'any.",
    muralWrong: 'No ben bé. Fixa’t en els balladors que es donen la mà al mural…',
    shrine: 'Un petit altar al Déu de la Terra (土地公), que té cura del barri. Al matí, els botiguers li porten fruita i encenen encens.',
    shrineEn: 'Please keep our street safe.', // English practice
    pray: '🙏 Ajuntar les mans',
    prayed: "Fas tres reverències. El fum de l'encens puja fent espirals cap al cel.",
    marketMap: 'Mercat nocturn de Dongdamen (東大門夜市): un mercat enorme fet de quatre mercats antics. Carrer Indígena, Carreró del Continent, parades de Fuding i Ziqiang, jocs i música en directe. Obre cada vespre de 5 de la tarda a 12 de la nit.',
    marketQ: 'When does the night market open?',
    marketA: ['At five p.m.', 'At five a.m.', 'At twelve noon'],
    marketRight: "Correcte! A les cinc de la tarda s'encenen els llums i el fum de les graelles ho omple tot.",
    marketWrong: "Mmm, torna a mirar l'horari al mapa.",
    balloon: 'Rebenta els globus amb dards! Cinc dards per 10 monedes.',
    play: '🎯 Jugar (10 monedes)',
    balloonQ: 'How many balloons did you pop?',
    balloonRight: 'Ben comptat! La senyora et dona un adhesiu de premi.',
    balloonWrong: 'Torna a comptar els 💥!',
    nums: ['zero', 'one', 'two', 'three', 'four', 'five'],
    popped: (n: string) => `I popped ${n} balloons!`, // English practice
    creative: "Aquest parc era el celler de Hualien, construït a l'època japonesa fa uns cent anys. Avui els magatzems vells acullen exposicions, botiguetes i concerts.",
    creativeLook: '🏭 Treure el cap en un magatzem',
    creativeDone: "A dins: quadres d'artistes de la zona, un petit escenari i olor de fusta vella i de vi d'arròs de fa molt de temps.",
    creativeEn: 'This used to be a winery. Now it is an art park.', // English practice
    pine: "Pine Garden (松園別館), 1942: un edifici blanc de dues plantes de l'època japonesa, amb porxos, dalt d'un turó entre pins de Ryukyu de més de cent anys. Abans va ser una oficina de l'exèrcit; avui és un espai d'art i poesia amb vistes al riu Meilun i al Pacífic.",
    pineQ: 'What kind of trees grow around the Pine Garden?',
    pineA: ['Pine trees', 'Palm trees', 'Apple trees'],
    pineRight: 'Sí: pins de Ryukyu molt vells, recargolats pel vent del mar.',
    pineWrong: 'Torna a mirar el nom: 松 vol dir “pine” (pi).',
    riverMouth: "Aquí el riu Meilun (美崙溪) es troba amb l'oceà Pacífic. Els pescadors esperen a la barra de sorra i els martinets pesquen a l'aigua poc fonda.",
    riverEn: 'The river meets the sea.', // English practice
    lookAround: '🔭 Mirar pels prismàtics',
    lookedRiver: 'Veus el port, la desembocadura i, ben lluny, les muntanyes verdes que cauen dins el mar blau.',
    bikePath: 'El carril bici de la costa va arran de mar des del riu Meilun fins al sud de la ciutat. A trenc d’alba, la gent hi va en bici, hi corre i hi passeja el gos.',
    bikeQ: "Què dius quan avances algú en bici? (pràctica d'anglès)",
    bikeA: ['Excuse me, on your left!', 'Move, move!', 'Goodbye forever!'],
    bikeRight: 'Perfecte! Educat i clar. I toca el timbre!',
    bikeWrong: 'Això no és gaire amable. Torna-ho a provar!',
    seafront: 'El parc Beibin mira al Pacífic. Els matins clars, el sol surt del mar i de vegades es veuen barques de pesca tornant al port.',
    seaEn: 'The sun rises over the Pacific Ocean.', // English practice
    listen: '🌊 Escoltar les onades',
    listened: 'Xxxt… fiuuu… Els còdols rodolen amunt i avall amb cada onada.',
    photo: 'El Container Coffee està fet amb 29 contenidors de vaixell vells, apilats i sobresortint com peces gegants de construcció. Pels extrems de vidre hi entra la llum.',
    photoHow: "Demana a algú que passa que et faci una foto. Què li dius? (pràctica d'anglès)",
    photoA: ['Could you take a photo of me, please?', 'Photo me. Now.', 'Take my camera away!'],
    photoRight: 'Clic! Una foto perfecta amb els contenidors de colors al darrere.',
    photoWrong: 'Mmm, prova una manera més educada.',
    temple: 'El temple Qingxiu (慶修院) el van construir el 1917 uns pagesos japonesos que vivien a Ji’an. Amb la sala de fusta i els fanals de pedra, és un dels temples japonesos més ben conservats de Taiwan.',
    templeEn: 'This temple is more than one hundred years old.', // English practice
    wish: '🔔 Tocar la campana i demanar un desig',
    wished: 'Gonnng… El so greu recorre el jardí. Tanques els ulls i demanes un desig.',
    buddha: "Al llarg del camí hi ha estàtues de Buda de pedra, una per cada temple d'un famós pelegrinatge a l'illa de Shikoku, al Japó. Passar per davant de totes és com fer un pelegrinatge en miniatura.",
    buddhaQ: 'How many stone Buddhas are there?',
    buddhaA: ['Eighty-eight', 'Eighteen', 'Eight hundred'],
    buddhaRight: 'Sí, 88! Quatre fileres a cada costat del camí.',
    buddhaWrong: 'Torna a comptar: quatre fileres d’onze a cada costat…',
    paddy: "Els arrossars de Ji’an s'inunden amb aigua neta de la muntanya. Els martinets caminen entre les plantes d'arròs buscant granotes i peixos.",
    paddyQ: 'What do farmers grow in these fields?',
    paddyA: ['Rice', 'Ice', 'Rocks'],
    paddyRight: 'Correcte! Verd a la primavera i daurat a la tardor.',
    paddyWrong: "Fixa't bé en les plantes de dins l'aigua…",
    singer: 'Un cantant amb guitarra canta cançons taiwaneses antigues i èxits nous. Entre les parades, la gent pica de mans.',
    clap: '👏 Picar de mans',
    clapped: 'Tothom canta la tornada alhora. El cantant et saluda amb la mà!',
    singerEn: 'Thank you, Hualien! One more song?', // English practice
    shuttleRide: "🚌 Agafar l'autobús turístic",
    taxiEn: 'Could you take me to Dongdamen Night Market, please?', // English practice
    taxiQ: "Com li demanes al taxista amb educació? (pràctica d'anglès)",
    taxiA: ['Could you take me to Dongdamen Night Market, please?', 'Dongdamen. Drive.', 'Where is my taxi going?'],
    taxiRight: '“Sure! Seat belt on, please.” La pròxima vegada pots anar-hi a peu: és a només deu minuts!',
    taxiWrong: 'Una mica maleducat… prova amb una pregunta educada.',

    // Persones: frases en la llengua del jugador i una frase en anglès cadascuna (pràctica d'anglès).
    talk: {
      hc_stationStaff: {
        lines: ['Benvingut a Hualien! El Taroko Express des de Taipei triga unes dues hores.', "Els trens de tornada surten de l'andana 1. No perdis l'últim del vespre!", "La teulada de l'estació sembla una muntanya, i les columnes porten dibuixos amis."],
        en: 'Welcome to Hualien! Enjoy your trip.', // English practice
      },
      hc_taxiDriver: {
        lines: ['Taxi? Hualien és petita: el mercat nocturn és a deu minuts.', 'Fa vint anys que faig de taxista aquí. Conec tots els restaurants de fideus!', "Els turistes sempre em demanen d'anar a Taroko. Agafeu l'autobús turístic, que és més barat!"],
        en: 'Where would you like to go?', // English practice
      },
      hc_shuttleGuide: {
        lines: ['L’autobús turístic verd va a la Gorja de Taroko i a la platja de Qixingtan.', 'Tingues les monedes a punt i seu a la dreta per veure el mar!', "L'últim autobús torna abans que es faci fosc."],
        en: 'Does this bus go to Taroko Gorge?', // English practice
      },
      hc_dumplingGrandpa: {
        lines: ['El meu pare va venir de Shandong. Aquests raviolis són la seva recepta.', "Aquest carreró es diu Carreró del Continent: menjar de tota la Xina.", 'Doblegar, pessigar, pessigar, pessigar… Faig cinc-cents raviolis cada nit!'],
        en: 'How many would you like?', // English practice
      },
      hc_sausageVendor: {
        lines: ['Benvingut al Carrer Indígena! Nga’ay ho: així es diu «hola» en amis.', 'Arròs en bambú, botifarres a la brasa, pastissos de mill… tot ve de la muntanya i del mar.', 'Els nostres avis ens van ensenyar a compartir el menjar amb tothom.'],
        en: 'Nga’ay ho! Hello and welcome!', // English practice
      },
      hc_amisGrandma: {
        lines: ['Teixeixo aquestes polseres a mà. Cada color té un significat.', 'El vermell és la força, el blanc la puresa i el groc el sol.', 'La nostra festa de la collita és a l’estiu. Balla tot el poble!'],
        en: 'Did you make this by hand?', // English practice
      },
      hc_balloonVendor: {
        lines: ['Cinc dards, deu monedes! Rebenta tres globus i guanyes un premi!', 'Apunta al mig i llança suau.', 'Sovint els nens ho fan millor que els pares!'],
        en: 'Ready? Aim… throw!', // English practice
      },
      hc_singer: {
        lines: ['Canto aquí cada nit. Saps alguna cançó?', "Aquesta és una vella cançó d'amor de Hualien.", 'Pica de mans amb mi a la tornada!'],
        en: 'Thank you, Hualien! One more song?', // English practice
      },
      hc_cyclist: {
        lines: ['Cada matí faig el carril de la costa. El mar és diferent cada dia.', "Des d'aquí pots pedalar fins al sud de la ciutat.", "Posa't el casc i toca el timbre!"],
        en: 'On your left!', // English practice
      },
      hc_jogger: {
        lines: ['Bon dia! El passeig del riu és perfecte per córrer.', 'Avui he vist un bernat pescaire a la desembocadura.', 'Corre, respira i somriu!'],
        en: 'Good morning! Lovely day, isn’t it?', // English practice
      },
      hc_barista: {
        lines: ['Benvingut al Container Coffee! A dalt hi ha les millors vistes.', 'Els contenidors sobresurten perquè la seva ombra cobreixi la terrassa.', 'La nostra xocolata calenta és la preferida dels nens.'],
        en: 'What size would you like: small, medium or large?', // English practice
      },
      hc_caretaker: {
        lines: ['Cada matí escombro el camí de pedra, passant per davant dels 88 Budes.', 'Uns pagesos japonesos van construir aquest temple quan el poble es deia Yoshino.', 'Camina en silenci i fes una petita reverència davant la sala.'],
        en: 'Please walk quietly in the temple.', // English practice
      },
      hc_pineGuide: {
        lines: ['Aquests pins de Ryukyu tenen més de cent anys.', "Des del balcó es veu com el riu es troba amb l'oceà.", 'Aquí hi vénen poetes a escriure. Llegim un poema?'],
        en: 'The view from the top is beautiful.', // English practice
      },
      hc_farmer: {
        lines: ['L’arròs de Ji’an creix amb aigua neta de la Serralada Central.', 'Els martinets són els meus ajudants: es mengen els bitxos!', "Dues collites l'any: una a l'estiu i una a la tardor."],
        en: 'The rice is green now. In autumn it turns gold.', // English practice
      },
    },
  },
};
